import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import ProfileIconCard from '../ProfileIconCard/ProfileIconCard';

import { abilityToSell, USER_TYPE_YOUTH } from '../../util/types';
import { currentUserRole, getUserPermissions, cartItemsCount, isUserSyncShopify } from '../../util/data';
import { createResourceLocatorString } from '../../util/routes';

import css from "./LeftSideTabSidebar.module.css";
import { subscriptionPermissionRequest } from '../../ducks/user.duck';

const REDIRECTION_TYPE_SUB_TABS = "SUB_TABS";
const REDIRECTION_TYPE_LINK = "LINK";
const REDIRECTION_TYPE_BUTTON = "BUTTON";



const LeftSideTabSidebar = ({currentPage = "SearchPage" }) => {

  const intl = useIntl();
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const {
    currentUser,
    currentUserNotificationCount,
    currentUserNotificationCountForOffer,
  } = state.user;


  const notificationCount = currentUserNotificationCount || currentUserNotificationCountForOffer;

  const userId = currentUser?.id?.uuid;
  const { publicData, protectedData, privateData } = (currentUser && currentUser.id && currentUser.attributes?.profile) || {};
  const { userRole, parentId = false } = publicData || {};
  const { subscriptionData = false } = protectedData || {};
  const { cart } = privateData || {}
  const userSubscriptionRole = currentUserRole(currentUser);
  const userAbilityToSell = getUserPermissions(userSubscriptionRole, abilityToSell);
  const isShopifySyncEnabled = isUserSyncShopify(currentUser);

  const cartCount = cartItemsCount(cart) || 0;
  const isYouthRestricted = userRole === USER_TYPE_YOUTH && parentId && !subscriptionData;


  const menuData = [
    {
      Icon: <ProfileIconCard type="marketplace_bottom_mobile_svg" />,
      tab: "MARKETPLACE",
      label: intl.formatMessage({ id: "MobileHamburgerNavigation.MARKETPLACE" }),
      subLabel: intl.formatMessage({ id: "MobileHamburgerNavigation.MARKETPLACE_SUB" }),
      redirectionType: REDIRECTION_TYPE_LINK,
      pageName: "SearchPage",
      params: {},
      search: {},
      tabLevel: 1,
      subTabs: [
        {
          Icon: <ProfileIconCard type="marketplace_search_page" />,
          text: intl.formatMessage({ id: "MobileHamburgerNavigation.MARKETPLACE_SEARCH" }),
          tab: "MARKETPLACE_SERACH_PAGE",
          pageName: "SearchPage",
          params: {},
          search: {},
          redirectionType: REDIRECTION_TYPE_LINK,
          isActive: currentPage == "SearchPage",
        },
        ...(!isYouthRestricted ? [{
          Icon: <ProfileIconCard type="marketplace_cart_page" />,
          text: intl.formatMessage({ id: "MobileHamburgerNavigation.MARKETPLACE_CART_PAGE" }),
          tab: "MARKETPLACE_CART_PAGE",
          notificationCount: cartCount,
          pageName: "CartPage",
          params: {},
          search: {},
          redirectionType: REDIRECTION_TYPE_LINK,
          isActive: currentPage == "CartPage",
        }] : []),
        ...(userAbilityToSell || isShopifySyncEnabled ? [{
          Icon: <ProfileIconCard type="marketplace_manage_listings_page" />,
          text: intl.formatMessage({ id: "MobileHamburgerNavigation.MARKETPLACE_MANAGE_LISTINGS_PAGE" }),
          tab: "MARKETPLACE_MANAGE_LISTINGS_PAGE",
          pageName: "ManageListingsPage",
          params: {},
          search: {},
          redirectionType: REDIRECTION_TYPE_LINK,
          isActive: currentPage == "ManageListingsPage",
        }] : []),
        ...(!isYouthRestricted && userId ? [{
          Icon: <ProfileIconCard type="marketplace_inbox_base_page" />,
          text: intl.formatMessage({ id: "MobileHamburgerNavigation.MARKETPLACE_INBOX_BASE_PAGE" }),
          tab: "MARKETPLACE_INBOX_BASE_PAGE",
          pageName: "InboxBasePage",
          notificationCount: notificationCount,
          params: {},
          search: {},
          redirectionType: REDIRECTION_TYPE_LINK,
        }] : []),
        {
          text: intl.formatMessage({ id: "MobileHamburgerNavigation.MARKETPLACE_POST_ITEM" }),
          tab: "MARKETPLACE_POST_ITEM",
          type: "Button",
          disabled: false,
          onClick: () => {
            if(!userAbilityToSell){
              dispatch(subscriptionPermissionRequest(true,true));
              return null;
            }
            return history.push(createResourceLocatorString("NewListingPage", routeConfiguration, {}, {}));
          },
          redirectionType: REDIRECTION_TYPE_BUTTON,
        },
        // ...(!userId || isShopifySyncEnabled
        //   ? [
        //       {
        //         text: intl.formatMessage({
        //           id: 'MobileHamburgerNavigation.SHOPIFY_SYNC_BUTTON',
        //         }),
        //         tab: 'SHOPIFY_SYNC_BUTTON',
        //         pageName: false,
        //         type: 'ShopifyButton',
        //         disabled: false,
        //         redirectionType: REDIRECTION_TYPE_BUTTON,
        //         onClick: () => {
        //           if (!userId) {
        //             return history.push(
        //               createResourceLocatorString('SignupPage', routeConfiguration, {}, {})
        //             );
        //           }
        //           if (!isShopifySyncEnabled) {
        //             return null;
        //           }
        //           return history.push(
        //             createResourceLocatorString(
        //               'ShopifyOnboardingPageTab',
        //               routeConfiguration,
        //               { tab: 'connect' },
        //               {}
        //             )
        //           );
        //         },
        //       },
        //     ]
        //   : []),
      ],
      pages: [
        "SearchPage",
        "ListingPage",
        "CheckoutPage",
        "ListingPageVariant",
        "EditListingPage",
        "ListingPageCanonical",
        "InboxPage",
        "TransactionPage",
        "OrderDetailsPage",
        "SaleDetailsPage",
        "ManageListingsPage",
        "CartPage",
        "SubscriptionCheckoutPage",
        "GroupPaymentSuccessPage"
      ]
    },
  ];



  const navigateToPage = (section) => {
    const { tab, pageName, params = {}, search = {} } = section;
    if (pageName) {
      history.push(createResourceLocatorString(pageName, routeConfiguration, params, search));
      (pageName == "SearchPage" && search?.hierarchicalCategories && window) ? window?.location?.reload() : null;
      return;
    } else {
      // If the section does not have a pageName, just log the tab
      console.log(`Navigating to tab: ${tab}`);
    }
  }

  const handleMenuClick = (section) => {
    const { redirectionType, subTabs, onClick, type, isLast = false } = section;

    if (redirectionType === REDIRECTION_TYPE_SUB_TABS && subTabs && subTabs.length && !isLast) {

      return;
    };

    if (redirectionType === REDIRECTION_TYPE_LINK) {
      // If the section is a link, navigate to the corresponding page
      navigateToPage(section);
      return;
    };

    if (redirectionType === REDIRECTION_TYPE_BUTTON && onClick && type != "button") {
      // If the section is a button, handle the button click
      onClick();
      return;
    }

  };

  const handleButtonClick = (item) => {
    if (item.onClick) {
      item.onClick();
    }
  };

  const renderDivider = (key) => <div className={css.underline} key={key} />;

  const renderButton = (item, key) => (
    <button
      className={css.menuButton}
      disabled={item.disabled}
      key={key}
      onClick={() => handleButtonClick(item)}
    >
      {item.text}
    </button>
  );

   const renderShopifyButton = (item, key) => (
    <button
      className={css.shopifyButton}
      disabled={item.disabled}
      key={key}
      onClick={() => handleButtonClick(item)}
    >
      {item.text}
    </button>
  );

  const renderMenuItem = (item, key, isLast) => {
    return (<>
      <div key={key} className={item.isActive ? css.menusectionActive : isLast ? css.menuSectionInnerLast : css.menuSectionInner} onClick={() => handleMenuClick(item)}>
        {item.Icon ? <div className={css.menuItemIcon}>{item.Icon}</div> : null}
        <div className={
          item.isActive ? css.tabnameisActive :
            item.subTabs ? css.tabnameActive : css.tabname}>
          {typeof item.text === 'string' ? item.text : item.text?.props?.id}
        </div>
        {item.notificationCount ? <div className={css.notificationCount} > {item.notificationCount}</div> : null}
      </div>
      {item.subTabs ? <div className={css.discoverItems}>
        {renderSubMenu(item.subTabs, true)}
      </div>
        : null}
    </>);
  };

  const renderSubMenu = (subTabs, isLast) => (
    <div className={css.subMenu}>
      {subTabs.map((subItem, subKey) => {
        if (subItem.tab === 'UNDERLINE') return renderDivider(subKey);
        if (subItem.type === 'Button') return renderButton(subItem, subKey);
        if (subItem.type === 'ShopifyButton') return renderShopifyButton(subItem, subKey);
        return renderMenuItem(subItem, subKey, isLast);
      })}
    </div>
  );

  const subMenuOpen = menuData[0]

  return (subMenuOpen ? <div className={css.sidebar}>
    {subMenuOpen && subMenuOpen.subLabel ? (
      <div className={css.subMenuOpenSubLabel}>
        {subMenuOpen.subLabel}
      </div>
    ) : null}

    {subMenuOpen
      ? renderSubMenu(Array.isArray(menuData.find((st) => st.tab === subMenuOpen?.tab)?.subTabs) ? menuData.find((st) => st.tab === subMenuOpen?.tab)?.subTabs : [])
      : null}
  </div>
    : <></>
  );
};

export default LeftSideTabSidebar;
